import { ApexSuccess as ApexSuccess$1 } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var BlockApexSuccess = function BlockApexSuccess(_ref) {
  var index = _ref.index,
    _ref$innerBlocks = _ref.innerBlocks,
    innerBlocks = _ref$innerBlocks === void 0 ? [] : _ref$innerBlocks;
  return /*#__PURE__*/React.createElement(ApexSuccess$1, {
    key: index
  }, generateBlockList({
    blocks: innerBlocks
  }));
};
BlockApexSuccess.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var ApexSuccess = BlockApexSuccess;

export { ApexSuccess as default };
